module.exports = __webpack_public_path__ + "assets/pdf/placeholder.6ebface8.pdf";